<script>
  // @ts-check
  // @ts-ignore
  // eslint-disable-next-line
  import * as Types from "./globalNavigationTypes";
  import { tick } from "svelte";
  import Constants from "./globalNavigationConstants";
  import { getTheme } from "../../utilities/themes";

  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  /** @type {HTMLElement | undefined}  */
  let labelLinkElement;

  /** @type {import('../../utilities/themes').ThemeName} */
  export let theme;

  /** @type {Types.Link} */
  export let link;

  export let displayedMobileSection = undefined;

  const currentTheme = getTheme(theme);
  const linkLabel = link?.label.replace(/\s/g, "");
</script>

<svelte:element
  this="button"
  bind:this={labelLinkElement}
  id={Constants.primaryLinkPrefixMobile + linkLabel}
  aria-controls={Constants.secondarySectionPrefixMobile + linkLabel}
  aria-expanded={link?.label === displayedMobileSection}
  on:click={async () => {
    dispatch("mobileLabelClicked", {
      displayedMobileSection: link?.label
    });
    // When svelte:element changes element it loses focus
    // So we use tick to compensate for that
    await tick();
    labelLinkElement?.focus();
  }}
  class="
    heading-md relative flex items-center
    transition
    {currentTheme.focusOutlineColor} 
    focus-visible:outline-dashed focus-visible:outline-offset-2
    {currentTheme.focusOutlineColor}  {currentTheme.focusTextColor}
    mt-4
    items-center
    justify-between
  "
>
  {link?.label}
</svelte:element>
